module.exports = __webpack_public_path__ + "static/media/webd2.b33afe53.jpg";